export const getErrorMessage = {
    methods: {
        getMessages(error){
            let msg = ""

            if(!error.response){
                return "Server error"
            }
            if(!error.response.data){
                return "Server error"
            }

            const err_list = error.response.data.error_list

            if(!err_list || err_list.length === 0){
                return "Undefined message"
            }
            for(let i = 0; i < err_list.length; i++){
                if(err_list[i]['code'] && err_list[i]['code'].length){
                    msg += 'Code: ' + err_list[i]['code']
                }

                if(err_list[i]['message'] && err_list[i]['message'].length){
                    msg += err_list[i]['message'] + '\n';
                } else if(err_list[i]) {
                  msg += err_list[i] + '\n';
                }

            }
            return msg.trim()
        }
    }
}
